/**
 * Cross-org audit log browser with filtering and CSV export.
 */
import { useState, useEffect } from 'react';
import { api } from '../../api';

export default function AuditBrowser() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ org_id: '', actor_uid: '', action: '', limit: 100 });

  async function fetchAudit() {
    setLoading(true);
    const params = new URLSearchParams({ limit: filters.limit });
    if (filters.org_id) params.set('org_id', filters.org_id);
    if (filters.actor_uid) params.set('actor_uid', filters.actor_uid);
    if (filters.action) params.set('action', filters.action);
    try {
      const d = await api.get(`/ops_admin/audit?${params}`);
      setRows(d.audit || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { fetchAudit(); }, []);

  async function handleExport() {
    const params = new URLSearchParams();
    if (filters.org_id) params.set('org_id', filters.org_id);
    const resp = await api.raw('GET', `/ops_admin/audit/export?${params}`);
    const blob = await resp.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'ops_audit.csv';
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div className="ops-audit-browser">
      <div className="ops-page-header">
        <h1>Audit Log</h1>
        <button className="btn btn-sm btn-secondary" onClick={handleExport}>Export CSV</button>
      </div>

      <div className="ops-filters">
        <input className="form-input" placeholder="Org ID..." value={filters.org_id}
          onChange={e => setFilters(f => ({...f, org_id: e.target.value}))} />
        <input className="form-input" placeholder="Actor UID..." value={filters.actor_uid}
          onChange={e => setFilters(f => ({...f, actor_uid: e.target.value}))} />
        <input className="form-input" placeholder="Action (e.g. ORG_SUSPEND)..." value={filters.action}
          onChange={e => setFilters(f => ({...f, action: e.target.value}))} />
        <select className="form-input" value={filters.limit}
          onChange={e => setFilters(f => ({...f, limit: parseInt(e.target.value)}))}>
          <option value={50}>50 rows</option>
          <option value={100}>100 rows</option>
          <option value={500}>500 rows</option>
        </select>
        <button className="btn btn-sm btn-primary" onClick={fetchAudit}>Search</button>
      </div>

      {loading ? (
        <p className="loading-text">Loading...</p>
      ) : (
        <table className="ops-table ops-table-sm">
          <thead>
            <tr><th>Time</th><th>Actor</th><th>Role</th><th>Action</th><th>Org</th><th>Target</th><th>Reason</th></tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={7} className="empty-row">No records</td></tr>}
            {rows.map(r => (
              <tr key={r.id}>
                <td className="mono">{r.created_at ? new Date(r.created_at).toLocaleString() : '—'}</td>
                <td>{r.actor_email}</td>
                <td><span className="role-badge">{r.actor_role}</span></td>
                <td className="mono action-cell">{r.action}</td>
                <td className="mono">{r.org_id?.slice(0, 8) || '—'}</td>
                <td>{r.target_kind && `${r.target_kind}/${r.target_id?.slice(0, 8)}`}</td>
                <td className="reason-cell">{r.reason || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
